import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductMockup } from './ProductMockup';
export function Hero() {
  return <section className="relative bg-brand-darkgreen overflow-hidden pt-5 pb-24 px-6 lg:pt-8 lg:pb-32" data-id="element-19">
      {/* Subtle radial green glow top-right */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-medgreen/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-20"></div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col text-center mt-[0px] mb-[0px] items-center justify-start" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/5 text-white text-xs font-bold uppercase tracking-wider mb-5" data-id="element-23">
            <span data-id="element-24">🌿</span> Alimentación Natural para tu Mascota
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="md:text-5xl lg:text-6xl font-black text-white max-w-4xl mb-4 text-[20px]" data-id="element-25">
          ¿Sabés realmente{' '}
          <span className="text-brand-mint" data-id="element-26">qué le estás dando de comer</span> a
          tu mascota?
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full mb-6" data-id="element-27">
          <ProductMockup maxWidth="max-w-[420px]" data-id="element-28" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-29">
          <CTAButton onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-lg px-10 py-5" data-id="element-30">
            <span className="flex flex-col items-center leading-tight" data-id="element-31">
              <span data-id="element-32">Quiero la guía completa →</span>
              <span className="text-sm font-normal text-white/90" data-id="element-33">
                + App Digital
              </span>
            </span>
          </CTAButton>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="md:text-lg max-w-2xl mt-6 text-[12px] font-[500] text-[#ECE3E3]" data-id="element-34">
          El balanceado comercial tiene ingredientes que dañan a tu perro y tu
          gato a largo plazo. Esta guía te muestra cómo cambiarlo paso a paso
          desde casa.
        </motion.p>
      </div>
    </section>;
}